import { useState } from 'react';

export const useExpandableSections = (initialState = {}) => {
  const [expandedSections, setExpandedSections] = useState(initialState);

  const toggleSection = (section, subKey = null) => {
    if (subKey !== null) {
      setExpandedSections(prev => ({
        ...prev,
        [section]: {
          ...prev[section],
          [subKey]: !prev[section]?.[subKey]
        }
      }));
    } else {
      setExpandedSections(prev => ({
        ...prev,
        [section]: !prev[section]
      }));
    }
  };

  const expandAll = (section, keys = []) => {
    if (keys.length > 0) {
      const expanded = {};
      keys.forEach(key => {
        expanded[key] = true;
      });
      setExpandedSections(prev => ({
        ...prev,
        [section]: expanded
      }));
    } else {
      setExpandedSections(prev => ({
        ...prev,
        [section]: true
      }));
    }
  };

  const collapseAll = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: false
    }));
  };

  const isExpanded = (section, subKey = null) => {
    if (subKey !== null) {
      return expandedSections[section]?.[subKey] || false;
    }
    return expandedSections[section] || false;
  };

  return {
    expandedSections,
    toggleSection,
    expandAll,
    collapseAll,
    isExpanded,
  };
};
